export const defaultStyle = {}

export const NEWS_MAIN_PAGE = {
  newsMainWrapContainer: "newsMainWrapContainer",
  newsMainWrap:
    "NewsStoryWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[20px] md:px-[15px] ",
}
